import React, { useState } from 'react';

const AdminYoutubeApi = () => {
  const [formData, setFormData] = useState({
    region: 'KR',
    date: (() => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday.toISOString().split('T')[0]; // 어제 날짜
    })(),
    maxResults: 10,
    categoryId: [],
    searchKeyword: '',
    videoType: 'all',
    apiKey: 'AIzaSyAoeQE8DdFGq5froqeF5PDG9ZtQTck4-uY'
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);

  const regions = [
    { code: 'KR', name: '한국' },
    { code: 'US', name: '미국' },
    { code: 'JP', name: '일본' },
    { code: 'GB', name: '영국' },
    { code: 'CA', name: '캐나다' },
    { code: 'AU', name: '호주' },
    { code: 'DE', name: '독일' },
    { code: 'FR', name: '프랑스' },
    { code: 'BR', name: '브라질' },
    { code: 'IN', name: '인도' }
  ];

  // YouTube 카테고리 목록
  const categories = [
    { id: '', name: '전체 카테고리' },
    { id: '1', name: '영화 & 애니메이션' },
    { id: '2', name: '자동차' },
    { id: '10', name: '음악' },
    { id: '15', name: '애완동물 & 동물' },
    { id: '17', name: '스포츠' },
    { id: '19', name: '여행 & 이벤트' },
    { id: '20', name: '게임' },
    { id: '22', name: '인물 & 블로그' },
    { id: '23', name: '코미디' },
    { id: '24', name: '엔터테인먼트' },
    { id: '25', name: '뉴스 & 정치' },
    { id: '26', name: '스타일 & 뷰티' },
    { id: '27', name: '교육' },
    { id: '28', name: '과학 & 기술' },
    { id: '29', name: '비영리 & 사회운동' },
    { id: '30', name: '영화' },
    { id: '31', name: '애니메이션' },
    { id: '32', name: '액션 & 어드벤처' },
    { id: '33', name: '클래식' },
    { id: '34', name: '코미디' },
    { id: '35', name: '다큐멘터리' },
    { id: '36', name: '드라마' },
    { id: '37', name: '가족' },
    { id: '38', name: '외국' },
    { id: '39', name: '공포' },
    { id: '40', name: 'SF & 판타지' },
    { id: '41', name: '스릴러' },
    { id: '42', name: '단편' },
    { id: '43', name: '쇼' },
    { id: '44', name: '트레일러' }
  ];

  // 동영상 타입 목록
  const videoTypes = [
    { id: 'all', name: '전체 동영상' },
    { id: 'videos', name: '일반 동영상 (60초 초과)' },
    { id: 'shorts', name: '쇼츠 (60초 이하)' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 카테고리 다중 선택 핸들러
  const handleCategoryChange = (categoryId) => {
    setFormData(prev => {
      const currentCategories = prev.categoryId;
      if (currentCategories.includes(categoryId)) {
        // 이미 선택된 카테고리면 제거
        return {
          ...prev,
          categoryId: currentCategories.filter(id => id !== categoryId)
        };
      } else {
        // 선택되지 않은 카테고리면 추가
        return {
          ...prev,
          categoryId: [...currentCategories, categoryId]
        };
      }
    });
  };

  // 전체선택/전체해제 핸들러
  const handleSelectAllCategories = () => {
    setFormData(prev => {
      const allCategoryIds = categories.filter(cat => cat.id !== '').map(cat => cat.id);
      const currentCategories = prev.categoryId;
      
      // 현재 모든 카테고리가 선택되어 있으면 전체 해제, 아니면 전체 선택
      const isAllSelected = allCategoryIds.every(id => currentCategories.includes(id));
      
      if (isAllSelected) {
        return {
          ...prev,
          categoryId: []
        };
      } else {
        return {
          ...prev,
          categoryId: allCategoryIds
        };
      }
    });
  };

  // 카테고리 드롭다운 토글
  const toggleCategoryDropdown = () => {
    setCategoryDropdownOpen(!categoryDropdownOpen);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setResult(null);

    try {
      // URL 파라미터 구성
      const params = new URLSearchParams({
        region: formData.region,
        date: formData.date,
        maxResults: formData.maxResults,
        key: 'your-secret-key'
      });
      
      // 카테고리, 키워드, 동영상 타입이 있으면 추가
      if (formData.categoryId && formData.categoryId.length > 0) {
        params.append('categoryId', formData.categoryId.join(','));
      }
      if (formData.searchKeyword) {
        params.append('q', formData.searchKeyword);
      }
      if (formData.videoType && formData.videoType !== 'all') {
        params.append('videoType', formData.videoType);
      }
      
      const response = await fetch(`/api/youtube/import?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'API 호출 실패');
      }

      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-youtube-api-page">
      <h2>유튜브 동영상 API 관리</h2>
      <p className="description">
        YouTube 인기 동영상을 가져와서 post 테이블에 저장합니다.
      </p>

      <div className="form-section">
        <h3>동영상 API 호출 설정</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="region">지역 선택:</label>
            <select
              id="region"
              name="region"
              value={formData.region}
              onChange={handleInputChange}
              required
            >
              {regions.map(region => (
                <option key={region.code} value={region.code}>
                  {region.name} ({region.code})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="date">날짜:</label>
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              required
            />
            <small>해당 날짜의 인기 동영상을 가져옵니다.</small>
          </div>

          <div className="form-group">
            <label htmlFor="maxResults">가져올 동영상 수:</label>
            <input
              type="number"
              id="maxResults"
              name="maxResults"
              value={formData.maxResults}
              onChange={handleInputChange}
              min="1"
              max="50"
              required
            />
            <small>1-50개 사이로 설정하세요. (기본값: 10)</small>
          </div>

          <div className="form-group">
            <label htmlFor="categoryId">카테고리 선택:</label>
            <div className={`category-select-container ${categoryDropdownOpen ? 'open' : ''}`}>
              <button
                type="button"
                className="category-select-button"
                onClick={toggleCategoryDropdown}
              >
                {formData.categoryId.length === 0 ? '카테고리 선택' : formData.categoryId.map(id => categories.find(cat => cat.id === id)?.name).join(', ')}
              </button>
              {categoryDropdownOpen && (
                <div className="category-dropdown">
                  {/* 전체선택 체크박스 */}
                  <label className="category-option select-all-option">
                    <input
                      type="checkbox"
                      checked={formData.categoryId.length === categories.filter(cat => cat.id !== '').length && categories.filter(cat => cat.id !== '').length > 0}
                      onChange={handleSelectAllCategories}
                    />
                    전체선택
                  </label>
                  <div className="category-divider"></div>
                  {categories.map(category => (
                    <label key={category.id} className="category-option">
                      <input
                        type="checkbox"
                        value={category.id}
                        checked={formData.categoryId.includes(category.id)}
                        onChange={() => handleCategoryChange(category.id)}
                      />
                      {category.name}
                    </label>
                  ))}
                </div>
              )}
            </div>
            <small>특정 카테고리의 동영상만 가져옵니다. (선택사항)</small>
          </div>

          <div className="form-group">
            <label htmlFor="searchKeyword">검색 키워드:</label>
            <input
              type="text"
              id="searchKeyword"
              name="searchKeyword"
              value={formData.searchKeyword}
              onChange={handleInputChange}
              placeholder="예: 게임, 음악, 요리 등"
            />
            <small>특정 키워드가 포함된 동영상을 검색합니다. (선택사항)</small>
          </div>

          <div className="form-group">
            <label htmlFor="videoType">동영상 타입:</label>
            <select
              id="videoType"
              name="videoType"
              value={formData.videoType}
              onChange={handleInputChange}
            >
              {videoTypes.map(type => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
            <small>일반 동영상과 쇼츠를 구별하여 가져옵니다. (선택사항)</small>
          </div>

          <div className="form-group">
            <label htmlFor="apiKey">YouTube API 키:</label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={formData.apiKey}
              onChange={handleInputChange}
              required
              placeholder="YouTube Data API v3 키를 입력하세요"
            />
            <small>YouTube Data API v3 키가 필요합니다.</small>
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={isLoading}
          >
            {isLoading ? '처리 중...' : 'YouTube API 호출'}
          </button>
        </form>
      </div>

      {error && (
        <div className="error-section">
          <h3>오류 발생</h3>
          <div className="error-message">
            {error}
          </div>
        </div>
      )}

      {result && (
        <div className="result-section">
          <h3>API 호출 결과</h3>
          <div className="result-info">
            <p><strong>지역:</strong> {result.region}</p>
            <p><strong>처리된 동영상 수:</strong> {result.processedCount || 0}</p>
            <p><strong>성공:</strong> {result.success ? '예' : '아니오'}</p>
            {result.message && <p><strong>메시지:</strong> {result.message}</p>}
          </div>
          
          {result.videos && result.videos.length > 0 && (
            <div className="videos-list">
              <h4>가져온 동영상 목록:</h4>
              <div className="videos-grid">
                {result.videos.map((video, index) => (
                  <div key={index} className="video-item">
                    <div className="video-thumbnail">
                      <img src={video.thumbnail} alt={video.title} />
                      <span className="ranking">#{video.ranking}</span>
                    </div>
                    <div className="video-info">
                      <h5>{video.title}</h5>
                      <p className="channel">{video.channelTitle}</p>
                      <p className="views">조회수: {video.viewCount}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="info-section">
        <h3>사용법 안내</h3>
        <ul>
          <li>지역을 선택하여 해당 국가의 인기 동영상을 가져올 수 있습니다.</li>
          <li>날짜를 설정하면 해당 날짜의 인기 동영상을 조회합니다.</li>
          <li>가져온 동영상은 자동으로 post 테이블에 저장되며, 피드에서 확인할 수 있습니다.</li>
          <li>API 소스가 'youtube_api'로 표시되어 일반 글과 구분됩니다.</li>
          <li>YouTube API 일일 할당량을 고려하여 적절한 횟수로 사용하세요.</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminYoutubeApi;
